import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";



export const getEligibilityCategories = createAsyncThunk(
    "getEligibilityCategories", async (thunkAPI) => {
    try {
        const response = await axios.get("https://web1024.docmaster.in:5010/eligibility/categories");
        return response.data;
    }

    catch (err) {
return thunkAPI.rejectWithValue(err.response?.data || err.message);    }

})


export const createEligibility=createAsyncThunk(
    "createEligibility",async(body,thunkAPI)=>
    {
        try{
            const response=await axios.post("https://web1024.docmaster.in:5010/eligibility",body)
            return response.data;
        }
        catch(err)
        {
            return thunkAPI.rejectWithValue(err.response?.data || err.message);  

        }
    }
)


